export default (startDate, endDate) => {
    const since = startDate.clone(),
        until = endDate.clone();
    let dates = [];

    if (since && until) {
        const dateDiff = until.diff(since, 'days');

        for (let i = 0; i <= dateDiff; i++) {
            dates.push(since.format('DD/MM/YYYY'));
            since.add(1, 'days');
        }
    }

    return dates;
}


// WEBPACK FOOTER //
// ./src/utils/getBetweenDates.js